import { Route } from '@angular/router';

import { authRoutes } from './core/auth/auth.routes';
import { authGuard } from './core/auth/guards/auth.guard';
import { noAuthGuard } from './core/auth/guards/no-auth.guard';
import { mainRoutes } from './core/main/main.routes';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    children: authRoutes,
    canActivate: [noAuthGuard],
  },
  {
    path: '',
    children: mainRoutes,
    canActivate: [authGuard],
  },
];
